import en from './en';
import cn from './cn';
import dy from './dy';
import ry from './ry';
import hy from './hy';
import fy from './fy';
import ey from './ey';
import xby from './xby';
import ptyy from './ptyy';
import ydly from './ydly';
import yny from './yny';
import alby from './alby';
export default {
  en,
  cn,
  dy,
  ry,
  hy,
  fy,
  ey,
  xby,
  ptyy,
  ydly,
  yny,
  alby
}



// WEBPACK FOOTER //
// ./src/i18n/langs/index.js